import { render, staticRenderFns } from "./user-video.vue?vue&type=template&id=52db7683&"
import script from "./user-video.vue?vue&type=script&lang=js&"
export * from "./user-video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports